import {
  getCollector,
  postCollector,
  putCollector,
  bulkPostCollector,
  delCollector,
  bulkPutCollector,
} from 'src/apiHelper/collectorApi'
import {
  deleteFromSettingsServer,
  getSettings,
  postToSettingsServer,
  putDataToSettingsServer,
} from 'src/apiHelper/settingsApi'
import {
  getFromSocketServer,
  postToSocketServer,
  putDataToSocketServer,
} from 'src/apiHelper/socketApi'
import { delFusion, getFusion, postFusion, putFusion } from 'src/apiHelper/fusionApi'
import { SETTINGS_URL } from '../apiHelper/apiRoute/settings'

export const getProgressNoteTemplates = () => getSettings(SETTINGS_URL.GET_MEDICALCHARTTEMPLATES)

export const getMips = (data) => postFusion('v1/mips/measures/available', data)
export const getPatientEventByCharge = (chargeId) =>
  getFusion('v1/patient_event/charge/' + chargeId)

export const getPatientEventByPatientId = (patientId) =>
  getFusion('v1/patient_event/patient/' + patientId)

export const getUserScheduledReports = () => getFusion('v1/claimocityreport/list_reports')

export const getScheduledReportsMailer = () => getFusion('v1/claimocityreport/mailer_list')

export const createScheduledReport = (data) => postFusion('v1/claimocityreport/create_report', data)

export const updateScheduledReport = (data) => putFusion('v1/claimocityreport/update_report', data)

export const deleteScheduledReport = (id) => delFusion('v1/claimocityreport/delete_report?id=' + id)

export const createPatientEvent = (payload) => postFusion('v1/patient_event', payload)

export const updatePatientEvent = (payload) => putFusion('v1/patient_event', payload)

export const updatePatientFacilityEvent = (payload) =>
  postFusion('v1/patient_event/facility_update', payload)

export const clearPatientEvent = (chargeId, type) =>
  delFusion(`v1/patient_event/charge/${chargeId}/${type}`)

export const createScripturePatient = (patientId) =>
  postFusion(`v1/patient/scriptsure/create_patient/${patientId}`)

export const getScriptsureIframe = (patientId) =>
  getFusion(`v1/patient/scriptsure/iframe/${patientId}`)

export const getMySnippets = () => getSettings(`currentprovider/snippets`)
export const addMySnippets = (data) => postToSettingsServer(`currentprovider/snippets`, data)
export const removeThisSnippets = (id) => deleteFromSettingsServer(`currentprovider/snippets/${id}`)
export const editThisSnippets = (id, data) =>
  putDataToSettingsServer(`currentprovider/snippets/${id}`, data)

export const sortAllSnippets = (data) => postToSettingsServer(`currentprovider/snippets/sort`, data)

export const getProgressNoteImage = (charge_id, meta = '') =>
  getCollector(`/charges/${charge_id}/chart/image?meta=${meta}`)
export const getProgressNoteRegenerate = (charge_id) =>
  postCollector(`/charges/${charge_id}/chart/regenerate`)
export const getProgressNoteConvertV2 = (charge_id) =>
  getCollector(`/charges/${charge_id}/chart/convertv2text`)

export const getFavProcedures = (data) => {
  return getSettings(
    `currentprovider/favprocedures?q=${data?.q ? data?.q : ''}&place_of_service=${
      data?.place_of_service ? data?.place_of_service : ''
    }${data?.template ? `&template=${data?.template}` : ''}`,
  )
}

export const getFavDiagnosis = (data) => {
  return getSettings(
    `${SETTINGS_URL.FAV_DIAGNOSIS}?q=${data?.q ? data?.q : ''}
      ${data?.template ? `&template=${data?.template}` : ''}`,
  )
}

export const getVisitDiagnosis = (charge_id) =>
  getCollector(`/dailycensus/visits/${charge_id}/diagnosis`)

export const downloadNotesPDF = (charge_id, meta = '') =>
  getCollector(`/charges/${charge_id}/chart/image?fileFormat=pdf&meta=${meta}`)

export const cloneNotes = (charge_id, data) =>
  postCollector(`/dailycensus/visits/${charge_id}/clonenotes`, data)

export const downloadAllNotesByIds = (visit_ids, includeDatePath = true) =>
  getCollector(
    `/charges/export/charts/series?fileFormat=pdf&visit_ids=${visit_ids}&includeDatePath=${includeDatePath}`,
    {
      responseType: 'blob',
      timeout: 30000,
    },
  ).catch((e) => {
    return e
  })

export const getVisitProcedures = (charge_id) =>
  getCollector(`/dailycensus/visits/${charge_id}/procedures`)

export const getImageFile = (filename, metadata = '') =>
  getCollector(`/dailycensus/files/image/${filename}?optimized=false&meta=${metadata}`)

export const deleteSingleDocument = (filename) => delCollector(`/facilities/${filename}/files`)

export const getVisitHistory = (visitId) => getCollector(`/dailycensus/visits/${visitId}/series/v2`)
export const getNoteHistory = (patientId, limit = 16) =>
  getCollector(`/dailycensus/visitsnotes/${patientId}/series/v2?limit=${limit}`)

export const putProgressNoteProcedures = (charge_id, data) =>
  putCollector(`/charges/${charge_id}/procedures`, data)

export const submitDiagCodes = (charge_id, data) =>
  putCollector(`/charges/${charge_id}/diagnosiscodes`, data)

export const getDiagnosisByCodes = (codes = []) => {
  let codeStr = ''

  // Append each item in the array as a query parameter
  codes.forEach((item, index) => {
    codeStr += `codes[${index}]=${encodeURIComponent(item)}&`
  })
  codeStr = codeStr.slice(0, -1)

  return getSettings('/diagnosisCodes/codes?' + codeStr)
}

export const getProceduresByCodes = (codes = []) => {
  let codeStr = ''

  // Append each item in the array as a query parameter
  codes.forEach((item, index) => {
    codeStr += `codes[${index}]=${encodeURIComponent(item)}&`
  })
  codeStr = codeStr.slice(0, -1)

  return getSettings('/procedurecodes/codes?' + codeStr)
}

export const saveBillingNotes = (charge_id, data) => {
  if (charge_id) {
    return putCollector(`/charges/${charge_id}/billingnotes`, data)
  }
}

export const changeEncounterType = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/encounterType`, data)

export const changeTeleHealth = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/telehealth`, data)

export const changeAdmitReason = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/admission_reason`, data).catch(() => {
    return { status: 'failure', reason: '500 from server' }
  })

export const changeRoom = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/room`, data).catch(() => {
    return { status: 'failure', reason: '500 from server' }
  })

export const changeHospiceRelated = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/hospicerelated`, data)

export const changeBillingLegalEntity = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/legalentity`, data)

export const changeSharedServiceProvider = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/incidentprovider`, data)

export const changeCareManagement = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/carecoordination`, data)

export const changeLongTermCare = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/longtermcare`, data)

export const changeAuthNumber = (charge_id, data) =>
  putCollector(`/dailycensus/visits/${charge_id}/auth_number`, data)

export const updateVisitFields = (
  charge_id,
  data,
  flags = { lateFlag: false, changedDOS: false, panel: false },
) =>
  putCollector(
    `/dailycensus/visits/${charge_id}/update?panel=${String(flags.panel)}${flags.lateFlag ? '&lateSign=true' : ''}${flags.changedDOS ? '&changedDOS=true' : ''}`,
    data,
  )

export const saveFilesToVisit = (data) => putCollector('/dailycensus/visits', data)

export const getVisitCharts = (charge_id) => getCollector(`/charges/${charge_id}/chart`)

export const getPatientsData = (currentDate, type) =>
  getCollector(`/v2/dashboard/practice/patients/${currentDate}/${type}`)
export const getEncounterData = (currentDate, type) =>
  getCollector(`/v2/dashboard/practice/encounters/${currentDate}/${type}`)
export const getRevenueData = (currentDate, type) =>
  getCollector(`/v2/dashboard/practices/revenue/${currentDate}/${type}`)
export const getRvuData = (currentDate, type) =>
  getCollector(`/v2/dashboard/practice/rvu/${currentDate}/${type}`)

export const saveChartProgressNote = (visit_id, data, meta = '') =>
  putCollector(`charges/${visit_id}/chart${meta ? `?meta=${meta}` : ''}`, data)
export const signChartProgressNote = (visit_id, data) =>
  postCollector(`charges/${visit_id}/chart/sign`, data || {})
export const checkMIPSProgressNote = (visit_id) =>
  getCollector(`dailycensus/visits/${visit_id}/mipsvalidate`, {})

export const billVisitSubmit = (visit_id) =>
  postCollector(`dailycensus/visits/${visit_id}/submitbill`, {})

export const setBulkVisitRecall = (body) =>
  bulkPostCollector(`dailycensus/v2/visits/bulkrecallbill`, body)

export const getConversations = (data) => {
  return getFromSocketServer(`/conversations?q=${data?.q}&page=${data?.page}&type=${data?.type}`)
}
export const listContactList = () => {
  return getSettings('currentpractice/contactlist')
}
export const listPlaceOfService = () => {
  return getSettings('search/searchPlaceOfService?q=&enabled=true&limit=100')
}

export const getCurrentUser = (config = {}) => getSettings('currentuser', config)

export const getPicture = (fileName) => {
  if (!fileName) {
    return 'File not found'
  }
  return getCollector('/dailycensus/files/image/' + fileName)
}

export const getReadConversation = (id) => {
  return getFromSocketServer(`/conversations/${id}/read`)
}

export const updateUnreadConversation = (id, userInfo) => {
  return putDataToSocketServer(`/conversations/${id}/viewed`, userInfo)
}
export const updateArchiveStatus = (req) => {
  return putDataToSocketServer(`/conversations/${req.id}/messagetype/${req.status}`, {})
}
export const createGroupConversation = (body) => postToSocketServer(`/conversations`, body)

export const createConversation = (conversation_id, body) =>
  postToSocketServer(`/conversations/${conversation_id}`, body)

export const updateConversation = (conversation_id, body) =>
  putDataToSocketServer(`/conversations/${conversation_id}/title`, body)

export const downloadFile = (fileName) => getFromSocketServer(`/conversations/chat/${fileName}`)

export const getFileSeriesPatient = (patientId) => getCollector(`files/patient/${patientId}`)
export const getVisitAttachments = (visitId) => getCollector(`files/charge/${visitId}`)
export const getPatientData = (patientId) => getCollector(`/patients/v2/${patientId}`)
export const saveMIPSData = (visitId, data) => bulkPutCollector(`/charges/${visitId}/mips`, data)

export const getPractice = (config = {}) => getSettings(SETTINGS_URL.GET_PRACTICE, config)

export const searchCPT = (q, pos) =>
  getSettings(`currentprovider/procedures?q=${q}&place_of_service=${pos ? pos : ''}`)

export const getProviders = (config = {}) => getSettings(SETTINGS_URL.GET_PROVIDER, config)
export const currentProvider = () => getSettings(SETTINGS_URL.CURRENT_PROVIDER)
export const currentPractice = () => getSettings(SETTINGS_URL.CURRENT_PRACTICE)
export const currentSettings = () => getSettings(SETTINGS_URL.USER_SETTINGS)
export const currentRoles = () => getSettings(SETTINGS_URL.USER_ROLE)
export const currentPermissions = () => getSettings(SETTINGS_URL.USER_PERMISSION)
export const currentFeatures = () => getSettings(SETTINGS_URL.USER_FEATURE)

export const getUnreadConversations = (data) => {
  return getFromSocketServer(
    `/conversations/unread?q=${data?.q}&page=${data?.page}&type=${data?.type}`,
  )
}

export const getProviderConversations = (data) => {
  return getFromSocketServer(
    `/conversations/providerList?q=${data?.q}&page=${data?.page}&type=${data?.type}`,
  )
}

export const postCensusConvo = (visitId) => {
  return postCollector(`/dailycensus/visits/${visitId}/conversation`)
}

export const setVisitVoid = (visitId) => {
  return postCollector(`/dailycensus/visits/${visitId}/void`)
}

export const postMessageCensusConvo = (convoId, data) => {
  return postToSocketServer(`/conversations/${convoId}`, data)
}

export const favPatient = (id) => {
  return postCollector(`dailycensus/patients/${id}/favorite `)
}

export const unFavPatient = (id) => {
  return delCollector(`dailycensus/patients/${id}/favorite`)
}

export const getPatientAdvSearch = (data) =>
  getCollector(
    `dailycensus/patientsDuplicateCheck?&lastname=${data?.lastname}&dob=${data?.dob}&gender=${data?.gender}`,
  )
export const deleteNotes = (chart_id) => {
  return delCollector(`/v2/progressnote/${chart_id}`)
}

export const getPatientsVisitDetailsByVisitId = (id) => getCollector(`dailycensus/visits/${id}`)
export const getReason = (id) => getSettings(`settings/taskstatus/${id}/reasons`)
export const setStatus = (data, taskId) => {
  return postCollector(`tasks/${taskId}/setstatus`, data)
}
export const setChargeClaimStatus = (data) => {
  return postCollector(`charges/chargeclaimstatus`, data)
}
export const getInitialprocedures = () => getCollector(`dailycensus/visits/initialprocedures`)

export const updateCareTeam = (visitId, data) =>
  putCollector(`dailycensus/visits/${visitId}/careteam`, data)

export const favoriteFacilityUpdate = (facility_id) =>
  putDataToSettingsServer('currentprovider/favfacility/' + facility_id)
export const unfavoriteFacilityUpdate = (facility_id) =>
  deleteFromSettingsServer('currentprovider/favfacility/' + facility_id)

export const favoriteModifier = (modifier) =>
  putDataToSettingsServer('currentprovider/favmodifier/' + modifier)
export const unfavoriteModifier = (modifier) =>
  deleteFromSettingsServer('currentprovider/favmodifier/' + modifier)

export const updateChargeMDM = (chargeId, newMDM) =>
  postFusion(`v1/charge/ai-procedures/${chargeId}/mdm-elements`, newMDM)

export const getChargeMDM = (chargeId, newMDM) =>
  getFusion(`v1/charge/ai-procedures/${chargeId}/mdm-elements`)

export const getEncounterDefaults = (chargeId) =>
  getFusion(`v1/charge/ai-procedures/${chargeId}/encounter-defaults`)

export const getMostRecentChargeByPatient = (patientId) =>
  getCollector(`/patients/latest/${patientId}`)
